const resource = 'visits'

export default $axios => ({
  create(params) {
    return $axios.$post(`/${resource}`, params)
  },
  delete(visits) {
    return $axios.$delete(`/${resource}`, { data: { visits } })
  },

  getServiceName: name => 'visitService',
})
